module.exports = __webpack_public_path__ + "static/img/image_home_balance_background.1a85213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image_home_balance_background.png
// module id = 251
// module chunks = 1